export default __webpack_public_path__ + "static/media/journal.2d8fb0e9.svg";